// ---------------------------------------------------------------------------
// The identity of a background in a list.
//
// A background is addressed by its `variation`: the catalog doc number for a
// catalog entry. The `position` (the number on the tile) is display order
// only. Stored data — `bgOption`, `default_scenes.background` — keeps the
// variation, so a reorder never changes which image a default, a crop, or a
// saved scene points at. The URL names a tile by its number (`?bg=`, see
// libs/bgNumbering.ts), and a background without one by its variation
// (`?background=`).
//
// A draft upload has no catalog doc until the list is published. It gets a
// stable synthetic variation from its upload id, above every catalog number,
// so it can be selected like any other entry.
// ---------------------------------------------------------------------------

/** Every synthetic draft-upload variation is at or above this number. */
export const DRAFT_UPLOAD_VARIATION_FLOOR = 10 ** 13;

/** The stable synthetic variation of a draft upload (`uploadId` is hex). */
export function draftUploadVariation(uploadId: string): number {
  const n = parseInt(uploadId.slice(0, 10), 16);
  if (!Number.isFinite(n)) {
    throw new Error(`Upload id "${uploadId}" is not hex`);
  }
  return DRAFT_UPLOAD_VARIATION_FLOOR + n;
}

/** True when a variation names a draft upload, not a catalog doc. */
export function isDraftUploadVariation(variation: unknown): boolean {
  const n = Number(variation);
  return Number.isInteger(n) && n >= DRAFT_UPLOAD_VARIATION_FLOOR;
}
